<template>
  <div class="vertical-storefront animated slideInDown">
    <div id="lottie"><canvas id="canvas"></canvas></div>
  </div>
</template>

<script>
import * as lottie from 'lottie-web/build/player/lottie.js'

export default {
  name: 'vertical-orange',
  props: ['animation', 'background', 'loop'],
  components: {
  },
  data() {
    return {
      shouldLoop: this.loop === "true"
    }
  },
  mounted() {
    let params = {
        container: document.getElementById('lottie'),
        renderer: 'html',
        loop: this.loop == true,
        autoplay: true,
        animationData: this.animation,
        rendererSettings: {
          context: document.getElementById('lottie'), // the canvas context
          scaleMode: 'noScale',
          clearCanvas: true,
          progressiveLoad: true, // Boolean, only svg renderer, loads dom elements when needed. Might speed up initialization for large number of elements.
          hideOnTransparent: true, //Boolean, only svg renderer, hides elements when opacity reaches 0 (defaults to true)
          className: 'animation'
        }
    };

    const element =  document.querySelector('.vertical-storefront')
    element.setAttribute('style', `background-image: url("${this.background}");`)
    element.addEventListener('animationend', () => {
      lottie.loadAnimation(params)
    })
  }
}
</script>

<style lang="scss" scoped>
.vertical-storefront {
  // background: transparent url("~@/assets/storefront.png") top center no-repeat;
  background-color: transparent;
  background-position: top center;
  background-repeat: no-repeat;
  background-size: contain;
  height: 100%;
  width: 100%;
}

#lottie{
  width:100%;
  height:65%;
  display:block;
  overflow: hidden;
  transform: translate3d(0,0,0);
  text-align: center;
  opacity: 1;
  z-index: 1;
}
</style>
